module.exports = __webpack_public_path__ + "static/img/iec27001.edb979e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iec27001.png
// module id = F2dQ
// module chunks = 1